import { Record } from '../transit'
import * as actions from './actions'

const State = Record({
  error: null,
}, 'auth')

const authReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.SIGN_IN_ERROR: {
      return state.set('error', action.payload)
    }
    case actions.CLEAR_ERRORS: {
      return state.set('error', null)
    }
    default:
      return state
  }
}

export default authReducer



// WEBPACK FOOTER //
// ./src/common/auth/reducer.js